<script>
import {Bar} from "vue-chartjs";

export default {
    name: "BarChart",
    extends: Bar,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        },
                        gridLines: {
                            display: false
                        },
                        display: false,
                        stacked: true
                    }],
                    xAxes: [{
                        ticks: {
                            display: false
                        },
                        gridLines: {
                            display: false
                        },
                        stacked: true
                    }],
                },
                legend: {
                    display: false,
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                layout: {
                    padding: {
                        top: 50,
                        bottom: 20
                    }
                },
                animation: {
                    onProgress: function () {
                        let chartInstance = this.chart;
                        let ctx = chartInstance.ctx;
                        chartInstance.data.datasets.forEach(function (dataset, i) {
                            if (!!dataset.days) {
                                let meta = chartInstance.controller.getDatasetMeta(i);
                                meta.data.forEach(function (bar, index) {
                                    ctx.save()
                                    ctx.font = '12px Berlin';
                                    ctx.fillStyle = '#828282'
                                    ctx.textAlign = "center"
                                    ctx.translate(bar._model.x, bar._model.y - 30);
                                    ctx.rotate(74)
                                    ctx.fillText(dataset.days[index], 0, 0);
                                    ctx.restore();
                                })
                            }
                        });
                    }
                },
            }
        }
    },
    mounted() {
        const vm = this
        vm.initChart()
    },
    methods: {
        initChart() {
            const vm = this

            vm.addPlugin({
                afterDraw: chart => {
                    let ctx = chart.chart.ctx;
                    let xAxis = chart.scales['x-axis-0'];
                    let yAxis = chart.scales['y-axis-0'];
                    let minValue = Math.min.apply(null, chart.data.labels)
                    ctx.save();
                    ctx.textAlign = 'center';
                    ctx.font = 'Berlin';
                    chart.data.labels.forEach((label, i) => {
                        ctx.fillStyle = '#828282'
                        if (minValue === label) ctx.fillStyle = 'rgba(255, 73, 85, .5)'
                        let meta = chart.getDatasetMeta(0);
                        let x = meta.data[i]._model.x;
                        ctx.fillText(label, x, yAxis.bottom + 17);
                    });
                    ctx.restore();
                }
            })

            vm.renderChart(vm.data, vm.options);
        }
    },
    watch: {
        data() {
            const vm = this
            vm.initChart()
        },
        options() {
            const vm = this
            vm.initChart()
        }
    }
};
</script>